export const config = {
    api: "https://us-central1-versatile-express.cloudfunctions.net/"
    //api: "http://127.0.0.1:5003/versatile-express/us-central1/"
}